import React from 'react';
import { types } from 'common/store/search/advanced/criteria';
import Plain from './plain';
import Choice from './choice';
import Datetime from './datetime';
import Location from './location';

const CriteriaType = (props) => {
  switch (props.criteria.type) {
    case types.CHOICE:
      return <Choice {...props} />;
    case types.DATETIME:
      return <Datetime {...props} />;
    case types.LOCATION:
      return <Location {...props} />;
    default:
      return <Plain {...props} />;
  }
};

export default CriteriaType;
